import React from "react";
import GenericDrawer from "./GenericDrawer.js";
import HamburgerMenuMobile from "../MenuV2/HamburgerMenuMobile.js";
import { useSelector, useDispatch } from "react-redux";
import { MenuSelectors } from "../../redux/selectors/index.js";
import { useClickOutside, useNoScroll } from "../../hooks/index.js";
import { MenuActionCreators } from "../../redux/action-creators/index.js";
import { DrawerType, VerticalTransition } from "../../constants/index.js";
import MobileDrawerHeader from "../MenuV2/MobileDrawerHeader.js";

const HamburgerDrawer = function () {
  const dispatch = useDispatch();

  const hamburgerMenuVisible = useSelector(MenuSelectors.hamburgerMenuVisible);

  const drawerRef = useClickOutside(
    () => {
      dispatch(MenuActionCreators.hideHamburgerMenu());
    },
    {
      disabled: !hamburgerMenuVisible
    }
  );
  useNoScroll("hamburgerDrawer", hamburgerMenuVisible);

  return (
    <GenericDrawer
      componentRef={drawerRef}
      isVisible={hamburgerMenuVisible}
      menu={DrawerType.HamburgerMenu}
      hasFavoriteSport={true}
      header={<MobileDrawerHeader menu={DrawerType.HamburgerMenu} />}
      className="hamburger-drawer"
      verticalTransition={VerticalTransition.Left}
    >
      <HamburgerMenuMobile />
    </GenericDrawer>
  );
};

export default React.memo(HamburgerDrawer);
